import Vue from "vue"


const state = {
    errorText: null,
};
const getters = {
    getText: state => state.errorText,
};

const actions = {
    async errorAction({ commit }, error) {
        commit('setError', error)
    },
};
const mutations = {
    setError(state, error) {
        state.errorText = error
    }
};
export default {
    state,
    getters,
    actions,
    mutations
};